var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgStatusPendingi = function SvgStatusPendingi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: props.color || 'currentColor'
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.5 7.5v1h-1v-1zm-2 0v1h-1v-1zm-2 0v1h-1v-1z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgStatusPendingi);
export default ForwardRef;